import { RootState } from "../../../../redux/rootReducers";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import {
  getAdvanceInvoiceCountAction,
  getMonthlyInvoiceCountGraphAction,
  resetInvoiceMonthlyGraphData,
  resetInvoiveCountData,
  resetListingError,
  resetListingSuccess,
} from "../../../../redux/listing";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  Loader,
} from "../../../../components/commons";
import {
  calculateDate,
  getCurrentFinancialYear,
  getLastSixMonths,
  getLastThreeMonths,
  previousFinancialYear,
  previousTwoFinancialYear,
} from "../../../../utils/commonFunctions";

import {
  InvoiceCountGraphDataType,
  InvoiceCountType,
} from "../../../../redux/listing/listingTypes";
import { BalanceSheetImage } from "../../../../assets/images";
import {
  GetAdvenceInvoiceCountPayloadType,
  GetInvoiceCountMonthlyPayloadType,
} from "../../../../commonTypes/listing";
import {
  resetReportsError,
  resetReportsSuccess,
} from "../../../../redux/reports";
import InvoiveCountTable from "../../../../components/AdminReports/AdvanceInvoiceCount/InvoiveCountTable";
import { INVOICE_COUNT_HEADERS } from "../../../../constant/tableHeadersConstants/invoiveCountHeaderConst";
import InvoiceCountMonthlyGraph from "../InvoiceCountGraph/InvoiceCountMonthlyGraph";
import moment from "moment";

// current year
const currentYear = getCurrentFinancialYear();
let finacialYear = currentYear;

// previous year
const previousYear = previousFinancialYear();
let previousFinacialYear = previousYear;

// previous two year
const previousTwoYear = previousTwoFinancialYear();
let previousTwoFinacialYear = previousTwoYear;

// 6 months
let lastSixMonths = getLastSixMonths();
let sixMonths = lastSixMonths;
// 3 Months
const lastThreeMonths = getLastThreeMonths();
let threeMonths = lastThreeMonths;
type DropDown = {
  label: string;
  value: string;
};

const fyDropDown: DropDown[] = [
  {
    label: "Last 3 Months",
    value: threeMonths,
  },
  {
    label: "Last 6 Months",
    value: sixMonths,
  },
  {
    label: "FY " + finacialYear,
    value: finacialYear,
  },
  {
    label: "FY " + previousFinacialYear,
    value: previousFinacialYear,
  },
  {
    label: " FY " + previousTwoFinacialYear,
    value: previousTwoFinacialYear,
  },
];

type AppProps = {
  token: string | null;
  fetching: boolean;
  error: string | null;
  success: number | null;
  statusCode: number | null;
  invoiceCount: [] | InvoiceCountType[];
  invoiceCountGraphData: InvoiceCountGraphDataType[] | [];
  dispatchResetReportsError: () => void;
  dispatchResetReportsSuccess: () => void;
  dispatchGetInvoiceCountAction: (
    data: GetAdvenceInvoiceCountPayloadType
  ) => void;
  dispatchResetInvoiceCount: () => void;
  dispatchResetSession: () => void;
  dispatchResetReportsErrorAction: () => void;
  dispatchMonthlyInvoiceCountGraphAction: (
    data: GetInvoiceCountMonthlyPayloadType
  ) => void;
  dispatchResetInvoiceGraphData: () => void;
};

const InvoicingAdvanceCounts = ({
  token,
  fetching,
  error,
  success,
  statusCode,
  dispatchResetReportsError,
  dispatchResetReportsSuccess,
  dispatchGetInvoiceCountAction,
  invoiceCount,
  dispatchResetInvoiceCount,
  dispatchResetReportsErrorAction,
  dispatchResetSession,
  dispatchMonthlyInvoiceCountGraphAction,
  invoiceCountGraphData,
  dispatchResetInvoiceGraphData,
}: AppProps) => {
  const [changeYear, setChangeYear] = useState<DropDown>({
    label: "FY " + finacialYear,
    value: finacialYear,
  });
  const [clientSelected, setClientSelected] = useState<any>({
    value: null,
    label: "All Client",
  });
  const [clientId, setClientId] = useState<any>(null);
  const [flag, setFlag] = useState<boolean>(false);
  const [graphData, setGraphData] = useState<InvoiceCountGraphDataType[]>([]);

  useEffect(() => {
    dispatchResetReportsError();
    dispatchResetReportsSuccess();
    dispatchResetInvoiceCount();
    dispatchResetInvoiceGraphData();
    setFlag(false);
    setGraphData([]);
  }, []);

  useEffect(() => {
    if(invoiceCountGraphData?.length){
      setGraphData([...invoiceCountGraphData]);
    }
    else{
      dispatchResetInvoiceGraphData();
      setGraphData([]);
    }
  }, [invoiceCountGraphData?.length]);

  useEffect(() => {
    if (changeYear.label === "Last 6 Months") {
      let finalMonthData: GetInvoiceCountMonthlyPayloadType = {
        token,
        start_date: changeYear?.value,
        end_date: moment().format("DD-MM-YYYY"),
        type: "month",
        client_code: clientId ? clientId : "",
      };
      dispatchMonthlyInvoiceCountGraphAction(finalMonthData);
      dispatchGetInvoiceCountAction(finalMonthData);
      setFlag(true);
    } else if (changeYear.label === "Last 3 Months") {
      let finalMonthData: GetInvoiceCountMonthlyPayloadType = {
        token,
        start_date: changeYear?.value,
        end_date: moment().format("DD-MM-YYYY"),
        type: "month",
        client_code: clientId ? clientId : "",
      };
      dispatchMonthlyInvoiceCountGraphAction(finalMonthData);
      dispatchGetInvoiceCountAction(finalMonthData);
      setFlag(true);
    } else {
      let finalMonthData: GetInvoiceCountMonthlyPayloadType = {
        token,
        start_date: `01-04-${changeYear?.value?.split("-")[0]}`,
        end_date: `31-03-${changeYear?.value?.split("-")[1]}`,
        type: "month",
        client_code: clientId ? clientId : "",
      };
      dispatchMonthlyInvoiceCountGraphAction(finalMonthData);
      dispatchGetInvoiceCountAction(finalMonthData);
      setFlag(true);
    }
  }, [clientId, changeYear]);

  const handleChangeClient = (client: any) => {
    setClientId(client.value);
    setClientSelected(client);
  };
  const handleDropChange = (e: DropDown) => {
    setChangeYear({
      label: e.label,
      value: e.value,
    });
  };
  let startDate = `01-04-${changeYear?.value?.split("-")[0]}`;
  let endDate = `31-03-${changeYear?.value?.split("-")[1]}`;

  if (changeYear?.label === "Last 6 Months") {
    startDate = changeYear?.value;
    endDate = moment().format("DD-MM-YYYY");
  }
  if (changeYear?.label === "Last 3 Months") {
    startDate = changeYear?.value;
    endDate = moment().format("DD-MM-YYYY");
  }

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetReportsError();
            }}
          />
        );
      }
    }

    return false;
  };

  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <CommonHeader title="Invoicing Counts" />
        </div>
      </div>

      <div>
        <div className="col-md-12 ">
          {invoiceCount && invoiceCount?.length === 0 && !fetching ? (
            <>
              {flag === true && (
                <div className="new-table-card mt-4">
                  <InvoiceCountMonthlyGraph
                    monthlyGraphData={graphData}
                    clientSelected={clientSelected}
                    handleChangeClient={handleChangeClient}
                    dispatchResetInvoiceGraphData={
                      dispatchResetInvoiceGraphData
                    }
                    fetching={fetching}
                    handleDropChange={handleDropChange}
                    changeYear={changeYear}
                    startDate={startDate}
                    endDate={endDate}
                    financialYear={finacialYear}
                  />
                </div>
              )}
              <div className="new-table-card mt-4 pt-4 pb-4">
                <EmptyListPage
                  title="No Data Found!"
                  text="Select a period to view the Invoice Count Details."
                  image={BalanceSheetImage}
                  imageWidth="30%"
                />
              </div>
            </>
          ) : (
            <>
              <div className="new-table-card mt-3">
                <InvoiceCountMonthlyGraph
                  monthlyGraphData={invoiceCountGraphData}
                  clientSelected={clientSelected}
                  handleChangeClient={handleChangeClient}
                  dispatchResetInvoiceGraphData={dispatchResetInvoiceGraphData}
                  fetching={fetching}
                  handleDropChange={handleDropChange}
                  changeYear={changeYear}
                  startDate={startDate}
                  endDate={endDate}
                  financialYear={finacialYear}
                />
              </div>
              <div className="new-table-card mt-4">
                <h5 className="text-center mt-4">Invoice Count</h5>
                <div className="d-flex justify-content-center mt-3">
                  <h6 className="text-center mr-4">
                    Start Date:{" "}
                    <span className="font-weight-bolder">{startDate}</span>
                  </h6>
                  <h6 className="text-center">
                    End Date:{" "}
                    <span className="font-weight-bolder">{endDate}</span>
                  </h6>
                </div>
                {changeYear?.value?.split("-")[1] ===
                  finacialYear?.split("-")[1] ||
                changeYear?.label === "Last 3 Months" ||
                changeYear?.label === "Last 6 Months" ? (
                  <h6 className="text-center" style={{ color: "#dd4433" }}>
                    As of Previous Date: {calculateDate()}
                  </h6>
                ) : (
                  ""
                )}

                <InvoiveCountTable
                  fetching={fetching}
                  data={invoiceCount}
                  tableHeaders={INVOICE_COUNT_HEADERS}
                />
              </div>
            </>
          )}
        </div>
      </div>
      {fetching && <Loader />}
      {handleErrorModal()}
    </>
  );
};
const mapStateToProps = (state: RootState) => ({
  success: state.listing.success,
  fetching: state.listing.fetching,
  token: state.auth.token,
  error: state.listing.error,
  statusCode: state.listing.statusCode,
  invoiceCount: state.listing.invoiceCount,
  invoiceCountGraphData: state.listing.invoiceCountGraphData,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetReportsSuccess: () => dispatch(resetListingSuccess()),
  dispatchResetReportsError: () => dispatch(resetListingError()),
  dispatchGetInvoiceCountAction: (data: GetAdvenceInvoiceCountPayloadType) =>
    dispatch(getAdvanceInvoiceCountAction(data)),
  dispatchResetInvoiceCount: () => dispatch(resetInvoiveCountData()),
  dispatchResetReportsErrorAction: () => dispatch(resetReportsError()),
  dispatchResetReportsSuccessAction: () => dispatch(resetReportsSuccess()),
  dispatchMonthlyInvoiceCountGraphAction: (
    data: GetInvoiceCountMonthlyPayloadType
  ) => dispatch(getMonthlyInvoiceCountGraphAction(data)),
  dispatchResetInvoiceGraphData: () => dispatch(resetInvoiceMonthlyGraphData()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InvoicingAdvanceCounts);
